import { FormattedProcessInformation } from "../components/AdminComplaints/types";

export const STATUS = [
  { value: "", label: "Todos" },
  { value: "RECEIVED", label: "Recibido", category: "neutral" },
  { value: "OPEN", label: "Abierto", category: "warning" },
  { value: "IN_CONSULTATION", label: "En consulta", category: "warning" },
  { value: "OBSERVED", label: "Observado", category: "warning" },
  { value: "REVIEWED", label: "Revisado", category: "ok" },
  { value: "WITH_RESPONSE", label: "Con respuesta", category: "ok" },
  { value: "CLOSE", label: "Cerrado", category: "problem" },
];

export const CATEGORY = [
  { value: "", label: "Todos" },
  { value: "COMPLAINT", label: "Quejas" },
  { value: "CLAIM", label: "Reclamos" },
];

export const NUMBER_OF_SUBTRACTED_DAYS = 90;

export const DEFAULT_SEARCH_PARAMS = {
  category: "",
  status: "",
  date: null,
  caseNumber: "",
};

export const COMPLAINANT_ID = {
  name: "",
  documentType: "",
  documentId: "",
  phoneNumber: "",
  mobileNumber: "",
  mail: "",
  role: "",
};

export const COMPLAINANT_INFO = {
  checkedQueja: true,
  business: "LOAD",
  date: new Date(),
  area: "",
  process: "",
  document: "",
  documentNumber: "",
  country: "peru",
  department: "lima",
  reason: "",
  currency: "",
  amount: "",
  caseDetail: "",
  demand: "",
  files: [],
};

export const BUSINESSES = [{ value: "LOAD", label: "Carga" }];

export const AREAS = {
  reclamo: [
    { value: "", label: "(Seleccione un área)" },
    { value: "IMPORT", label: "Importaciones" },
    { value: "EXPORT", label: "Exportaciones" },
    { value: "NATIONAL_CARGO", label: "Carga Nacional" },
  ],
  queja: [
    { value: "", label: "(Seleccione un área)" },
    { value: "IMPORT", label: "Importaciones" },
    { value: "EXPORT", label: "Exportaciones" },
    { value: "NATIONAL_CARGO", label: "Carga Nacional" },
    { value: "SYSTEMS", label: "Sistemas" },
    { value: "BILLING", label: "Facturación" },
    { value: "SECURITY", label: "Seguridad" },
    { value: "TRANSMISSIONS", label: "Transmisiones" },
    { value: "GHA", label: "GHA" },
  ],
};

export const LOAD_TYPE = [
  { value: "GENERAL", label: "General" },
  { value: "DANGEROUS", label: "Peligrosa" },
  { value: "VALUED", label: "Valorada" },
  { value: "PERISHABLE", label: "Perecible" },
  { value: "FROZEN", label: "Congelada" },
  { value: "PHARMACEUTICAL", label: "Farmacéutica" },
  { value: "MIXED", label: "Mixta" },
  { value: "CONTROLED-TEMPERATURE", label: "Temperatura controlada" },
  { value: "MASCOT", label: "Servicio mascota" },
];

export const PROCESSES = {
  IMPORT: [
    { value: "", label: "(Seleccione un proceso)" },
    { value: "RECEPTION", label: "Recepción" },
    { value: "INTEMEDIATES_SERVICES", label: "Servicios Intermedios" },
    { value: "OFFICE", label: "Despacho" },
  ],
  EXPORT: [
    { value: "", label: "(Seleccione un proceso)" },
    { value: "RECEPTION", label: "Recepción" },
    { value: "INTEMEDIATES_SERVICES", label: "Servicios Intermedios" },
    { value: "OFFICE", label: "Despacho" },
  ],
  NATIONAL_CARGO: [
    { value: "", label: "(Seleccione un proceso)" },
    { value: "RECEPTION", label: "Recepción" },
    { value: "OFFICE", label: "Despacho" },
  ],
  SYSTEMS: [
    { value: "", label: "(Seleccione un proceso)" },
    { value: "SYSTEMS", label: "Sistemas" },
  ],
  BILLING: [
    { value: "", label: "(Seleccione un proceso)" },
    { value: "BILLING", label: "Facturación" },
  ],
  SECURITY: [
    { value: "", label: "(Seleccione un proceso)" },
    { value: "SECURITY", label: "Seguridad" },
  ],
  TRANSMISSIONS: [
    { value: "", label: "(Seleccione un proceso)" },
    { value: "TRANSMISSIONS", label: "Transmisiones" },
  ],
  GHA: [
    { value: "", label: "(Seleccione un proceso)" },
    { value: "GHA", label: "GHA" },
  ],
};

export const DOCUMENTS = {
  queja: [
    { value: "", label: "(Seleccione un documento)" },
    { value: "MASTER_AIR_WAYBILL", label: "Guía Madre" },
    { value: "HOUSE_AIR_WAYBILL", label: "Guía Hija" },
    { value: "VOLANTE", label: "Volante" },
    { value: "BILLING", label: "Factura" },
    { value: "TICKET", label: "Ticket" },
  ],
  reclamo: [
    { value: "", label: "(Seleccione un documento)" },
    { value: "MASTER_AIR_WAYBILL", label: "Guía Madre" },
    { value: "HOUSE_AIR_WAYBILL", label: "Guía Hija" },
    { value: "VOLANTE", label: "Volante" },
    { value: "TICKET", label: "Ticket" },
  ],
};

export const COUNTRIES = [{ value: "peru", label: "Perú" }];

export const DEPARTMENTS = [
  { value: "amazonas", label: "Amazonas" },
  { value: "ancash", label: "Ancash" },
  { value: "apurimac", label: "Apurimac" },
  { value: "arequipa", label: "Arequipa" },
  { value: "ayacucho", label: "Ayacucho" },
  { value: "cajamarca", label: "Cajamarca" },
  { value: "callao", label: "Callao" },
  { value: "cusco", label: "Cusco" },
  { value: "huancavelica", label: "Huancavelica" },
  { value: "huanuco", label: "Huanuco" },
  { value: "ica", label: "Ica" },
  { value: "junin", label: "Junín" },
  { value: "la-libertad", label: "La Libertad" },
  { value: "lambayeque", label: "Lambayeque" },
  { value: "lima", label: "Lima" },
  { value: "loreto", label: "Loreto" },
  { value: "madre-de-dios", label: "Madre de Dios" },
  { value: "moquegua", label: "Moquegua" },
  { value: "pasco", label: "Pasco" },
  { value: "piura", label: "Piura" },
  { value: "puno", label: "Puno" },
  { value: "san-martin", label: "San Martín" },
  { value: "tacna", label: "Tacna" },
  { value: "tumbes", label: "Tumbes" },
  { value: "ucayali", label: "Ucayali" },
];

export const REASONS = {
  reclamo: [
    { value: "", label: "(Seleccione un motivo)" },
    { value: "MISSING_MERCHANDISE", label: "Faltante de mercadería" },
    {
      value: "TEMPERATURE_DEVIATION",
      label: "Desviación de temperatura",
    },
    { value: "OFFICE_LOAD_WRONG", label: "Despacho de carga errada" },
    { value: "LOAD_DAMAGE", label: "Daño a la carga" },
    { value: "CROSS_MERCHANDISE", label: "Cruce de mercadería" },
    { value: "WRONG_STORAGE", label: "Almacenamiento incorrecto" },
    { value: "OTHER", label: "Otro" },
  ],
  queja: [
    { value: "", label: "(Seleccione un motivo)" },
    {
      value: "DELAY_PROCESS",
      label: "Demora en procesos de atención",
    },
    {
      value: "SYSTEM_INCONSISTENCY",
      label: "Inconsistencia del sistema",
    },
    {
      value: "INCOMPLETE_PROCESSES",
      label: "Procesos incompletos",
    },
    {
      value: "ERRONED_REGISTRATION",
      label: "Registro errado de la información en el sistema",
    },
    { value: "SYSTEM_FAILURE", label: "Caída del sistema" },
    {
      value: "WRONG_BILLING",
      label: "Facturación errada",
    },
    { value: "OTHER", label: "Otro" },
  ],
};

export const CURRENCIES = [
  { value: "", label: "(Seleccione su moneda)" },
  { value: "PEN", label: "Soles" },
  { value: "USD", label: "Dólares" },
];

export const COMPLAINT_DETAIL_STEPS = {
  CLIENT_INFO: {
    order: 1,
    label: "Información del cliente",
  },
  COMPLAINT_INFO: {
    order: 2,
    label: "Información del caso",
  },
  PROCESS_INFO: {
    order: 3,
    label: "Información del proceso",
  },
  RESULT_INFO: {
    order: 4,
    label: "Información del resultado",
  },
};

export const COMPLAINT_PROCESS_INFO: FormattedProcessInformation = {
  id: "",
  involvedAreas: [],
  affectedAreas: [],
  loadType: [],
  processNumber: null,
  videoRequestDate: null,
  videoUploadDate: null,
  incidenceDate: null,
  traceabilityRequestDate: null,
  traceabilityDeliveryDate: null,
  responseDate: null,
  requestVideo: false,
  isIncidence: false,
  label: "",
  clientType: [],
  executiveName: "",
};

export const COMPLAINT_RESULT = {
  approvalDate: null,
  businessDays: "",
  responseMedium: "",
  observation: "",
  responseDays: "",
  pending: "",
  compensation: "",
  compensationProcess: "",
  responsibleForPayment: "",
  paymentDate: null,
  compensationFile: null,
  socialReason: "",
  bankAccount: "",
  bank: "",
  transactionDocument: "",
};

export const CLIENT_TYPES = [
  {
    label: "Agente de aduana",
    value: "CUSTOMS_ADUANA",
  },
  {
    label: "Exportador",
    value: "EXPORTER",
  },
  {
    label: "Agente de carga",
    value: "CUSTOM_AGENT",
  },
  {
    label: "Importador",
    value: "IMPORTER",
  },
  {
    label: "Aerolínea",
    value: "AIRLINE",
  },
  {
    label: "Persona Natural",
    value: "NATURAL_PERSON",
  },
];

export const INVOLVED_AFFECTED_AREAS = [
  { label: "Importación", value: "IMPORT" },
  { label: "Exportación", value: "EXPORT" },
  { label: "Carga Nacional", value: "NATIONAL_CARGO" },
  { label: "Sistemas", value: "SYSTEMS" },
  { label: "Facturación", value: "BILLING" },
  { label: "Seguridad", value: "SECURITY" },
  { label: "Transmisiones", value: "TRANSMISSIONS" },
  { label: "GHA", value: "GHA" },
];
